export default ({
  fetching: {
    getFields: false,
    getFieldModelById: false,
  },
  api: {
    tableFields: []
  },
});